import { render, staticRenderFns } from "./DuplicateTickets.vue?vue&type=template&id=647e8d63&"
import script from "./DuplicateTickets.vue?vue&type=script&lang=js&"
export * from "./DuplicateTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports